import service from '@/store/services/header-services'

const state = {
    list: {},
    item: {},
    meta: {},
    cate: {},
    newes: {},
    discount: {},
    website: {},
    // 后台内容保存
    gethome:{},
    getpage:{},
    getga_id:'',
    getseo:{},
    getads:{
        id: '',
        buy: ''
    },
    getmc:'',
    getfacebook: '',
    getnav: [],
    getfb: {},
    getyoutube: [],
    ga_state: true,
    navcontent:{},
    //文章
    article: [],
    isarticle: false,
    getgtm_id:''
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, item) => {
        state.item = item;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_CATE: (state, cate) => {
        state.cate = cate;
    },
    SET_NEWES: (state, newes) => {
        state.newes = newes;
    },
    SET_DISCOUNT: (state, discount) => {
        state.discount = discount;
    },
    SET_WEBSITE: (state, website) => {
        state.website = website;
    },
    SET_GETHOME: (state, gethome) => {
        state.gethome = gethome;
    },
    SET_GETPAGE: (state, getpage) => {
        state.getpage = getpage;
    },
    SET_GETGA_ID: (state, getga_id) => {
        state.getga_id = getga_id;
    },
    SET_GETSEO: (state, getseo) => {
        state.getseo = getseo;
    },
    SET_GETADS: (state, getads) => {
        state.getads = getads;
    },
    SET_GETMC: (state, getmc) => {
        state.getmc = getmc;
    },
    SET_GETFACEBOOK: (state, getfacebook) => {
        state.getfacebook = getfacebook;
    },
    SET_GETNAV: (state, getnav) => {
        state.getnav = getnav;
    },
    SET_GETFB: (state, getfb) => {
        state.getfb = getfb;
    },
    SET_GETYOUTUBE: (state, getyoutube) => {
        state.getyoutube = getyoutube;
    },
    SET_GA_STATE: (state, ga_state) => {
        state.ga_state = ga_state;
    },
    SET_NAVCONTENT: (state, navcontent) => {
        state.navcontent = navcontent;
    },
    SET_ARTICLE: (state, article) => {
        state.article = article;
    },
    SET_ISARTICLE: (state, isarticle) => {
        state.isarticle = isarticle;
    },
    SET_GETGTM_ID: (state, getgtm_id) => {
        state.getgtm_id = getgtm_id;
    }

};

const actions = {
    list({
        commit
    }, params) {
        commit('SET_CATE', params.CATE);
        commit('SET_NEWES', params.NEW);
        commit('SET_DISCOUNT', params.DISCOUNT);
    },
    // 获取oic
    get({
        commit
    }) {

        return service.getcartList().then((response) => {
            if (response.result) {
                commit('SET_CATE', response.data.CATE);
                commit('SET_NEWES', response.data.NEW);
                commit('SET_DISCOUNT', response.data.DISCOUNT);
            }
            // console.log(response);
            // console.log(params);
        });
    },
    // 获取图标fb 和 line等
    getwebsite({
        commit
    }, url) {
        return service.getwebsite(url).then((response) => {

            if (response.result) {
                commit('SET_WEBSITE', response.data)
            }
            // console.log(response);
            return response.data;

        })
    },
    getnav({
        commit
    }, clientUrl) {
        // console.log(clientUrl);
        // if (state.getnav && Object.keys(state.getnav).length > 0) {
        //     // 如果 Vuex store 中已经有 getnav 数据，直接返回这个数据
        //     return Promise.resolve(state.getnav);
        // }
        return service.getnav(clientUrl).then((response) => {
            // console.log(response,'modules-response');
            // console.log(response);
            let seo = {
                meta_description: '',
                og_title: '',
                og_url: '',
                meta_keywords: '',
                og_image: '',
                og_description: '',
            }
            for (const key in response) {
                switch (response[key].type) {
                    case 'home':
                        commit('SET_GETHOME', response[key].data)
                        break;
                    case 'page':
                        commit('SET_GETPAGE', response[key].data)
                        break;
                    case 'ga_id':
                        commit('SET_GETGA_ID', response[key].data)
                        break;
                    case 'seo':
                        commit('SET_GETSEO', response[key].data);
                        seo = response[key].data;
                        break;
                    case 'ads':
                        commit('SET_GETADS', response[key].data)
                        break;
                    case 'mc':
                        commit('SET_GETMC', response[key].data)
                        break;
                    case 'facebook':
                        commit('SET_GETFACEBOOK', response[key].data)
                        break;
                    case 'nav':
                        commit('SET_GETNAV', response[key].data)
                        break;
                    case 'youtube':
                        commit('SET_GETYOUTUBE', response[key].data)
                        break;
                    case 'article':
                        commit('SET_ARTICLE', response[key].data)
                        break;
                    case 'isarticle':
                        commit('SET_ISARTICLE', response[key].data)
                        break;
                    case 'gtm_id':
                        commit('SET_GETGTM_ID', response[key].data)
                        break;
                    default:
                        break;
                }
                // if (response[key].type == 'home') {
                //     commit('SET_GETHOME', response[key].data)
                // }
                // if (response[key].type == 'page') {
                //     commit('SET_GETPAGE', response[key].data)
                // }
                // if (response[key].type == 'ga_id') {
                //     commit('SET_GETGA_ID', response[key].data)
                // }
                // if (response[key].type == 'seo') {
                //     commit('SET_GETSEO', response[key].data)
                // }
                // if (response[key].type == 'ads') {
                //     commit('SET_GETADS', response[key].data)
                // }
                // if (response[key].type == 'mc') {
                //     commit('SET_GETMC', response[key].data)
                // }
                // if (response[key].type == 'facebook') {
                //     commit('SET_GETFACEBOOK', response[key].data)
                // }
                // if (response[key].type == 'nav') {
                //     commit('SET_GETNAV', response[key].data)
                // }
                // if (response[key].type == 'youtube') {
                //     commit('SET_GETYOUTUBE', response[key].data)
                // }

                
            }
            return seo;
        })
    },
    //获取fb内容
    getfb({
        commit
    }) {
        return service.getfb().then((response) => {
            commit('SET_GETFB', response.data)
        })
    }
}


const getters = {
    list: state => state.list,
    item: state => state.item,
    cate: state => state.cate,
    newes: state => state.newes,
    discount: state => state.discount,
    website: state => state.website.company_info,
    gethome: state => state.gethome,
    getpage: state => state.getpage,
    getga_id: state => state.getga_id,
    getseo: state => state.getseo,
    getads: state => state.getads,
    getmc: state => state.getmc,
    getfacebook: state => state.getfacebook,
    getnav: state => state.getnav,
    getfb: state => state.getfb,
    getyoutube: state => state.getyoutube,
    ga_state: state => state.ga_state,
    navcontent: state => state.navcontent,
    article: state => state.article,
    isarticle: state => state.isarticle,
    getgtm_id: state => state.getgtm_id
};

const header = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default header;